module.exports = __webpack_public_path__ + "static/media/poicon32.9c2dff13.svg";